import axios from 'axios';
import moment from 'moment';
import errorHandlerFactory from './errorHandler';
import { adaptSummaryFilters } from './adapters/filterAdapters';
import * as appConstants from '../common/constants';

const loadError = thingToLoad => errorHandlerFactory(`An error occured when fetching ${thingToLoad}.`);
const errorHandler = errorHandlerFactory('An error occured when creating a new Load Request.');

export const fetchLoadTypes = () => axios.get('/Jobs/LoadTypes')
    .then(r => r.data).catch(loadError('Load Types'));

export const fetchCategories = () => axios.get('/Jobs/Categories')
    .then(r => r.data).catch(loadError('Categories'));

export const fetchSourceTypes = () => axios.get('/Jobs/SourceTypes')
    .then(r => r.data).catch(loadError('Load request infor'));

export const loadRequestMappings = () => axios.get('/Jobs/DataLoadRequest')
    .then(r => r.data).catch(loadError('Source Types'));

export const fetchDataLoads = (filters = []) => {
    const filterToday = filters.find(x => x.value && x.value.today);
    if (filterToday && filterToday.value && filterToday.value.today) {
        return axios.get(`/Jobs/DataLoads/${moment().format(appConstants.dateFormat)}`)
            .then(r => r.data).catch(loadError('Data Loads'));
    }
    const filterObject = adaptSummaryFilters(filters);
    const newRequestObject = {
        startDate: filterObject.runStartDate,
        endDate: filterObject.runEndDate
    };
    return axios.get('/Jobs/DataLoadsbyDates', { params: newRequestObject })
        .then(r => r.data).catch(loadError('Data Loads'));
};

export const createNewLoadRequest = params => axios.post('/Jobs/CreateRequest', params)
    .then(r => r.data).catch(errorHandler);

export const fetchDataDetails = id => axios.get(`/Jobs/LoadDetails?requestId=${id}`)
    .then(r => r.data).catch(loadError('Data Details'));

export const rerunSelectedRows = params => axios.post('/Jobs/Rerun', params)
    .then(r => r.data).catch(errorHandler);
